import {Component, ElementRef, Injector, OnDestroy, OnInit} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {FormControl, FormGroup} from '@angular/forms';
import {PasswordRestoreService} from './password-restore.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-password-restore',
    templateUrl: 'password-restore.component.html',
    providers: [
        PasswordRestoreService,
    ]
})

export class PasswordRestoreComponent extends FrontendFormComponent implements OnDestroy {

    form = new FormGroup({
        token: new FormControl(''),
        password: new FormControl(''),
    });

    public isSent = false;

    private subs: Subscription[] = [];

    constructor(
        injector: Injector,
        public formService: PasswordRestoreService,
        private route: ActivatedRoute,
    ) {
        super(injector);
    }

    init() {
        this.subs.push(
            this.route.queryParams.subscribe((params) => {
                if (params && params.token) {
                    this.form.patchValue(params);
                    this.requestParams['token'] = params.token;
                }
            }),
        );
    }

    afterSave() {
        this.isPending = false;
        this.isSent = true;
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    /**
     * Отключаем уведомление об ошибках в полях, переопределяя родительский метод
     * @param error
     * @returns {null}
     */
    showErrorsNotification(error) {
        return null;
    }

}
